import { Oval } from "react-loader-spinner"

export default function Spinner({color}) {
    return (
        <Oval
            height={18}
            width={18}
            color={color ? color : "#00B0AD"}
            visible={true}
            ariaLabel='oval-loading'
            secondaryColor="#00b0ad2d"
            strokeWidth={4}
            strokeWidthSecondary={4}
        />
    )
}